import React from "react";
import Head from "next/head";
import { FluentResource } from "@fluent/bundle";

import Licenses from "@component/landing/sections/licenses";
import getLandingLayout from "@layout/persistent/landing";
import { newReactLocalization } from "@util/l10n";

LicensePage.getLayout = getLandingLayout;

const RESOURCES = {
  en: new FluentResource(`licenses-title = Licenses
`),
  es: new FluentResource(`licenses-title = Licencias
`),
};

const l10n = newReactLocalization(RESOURCES);

export default function LicensePage() {
  return (
    <div className="faq-page">
      <Head>
        <title>{l10n.getString("licenses-title")}</title>
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://kikoff.com/licenses" />
      </Head>
      <Licenses />
    </div>
  );
}
